import { Component, effect, inject, OnDestroy } from "@angular/core";
import { Router } from "@angular/router";
import { Observable, Subject } from "rxjs";
import { JhmTableComponent } from "../../components/jhm-table/jhm-table.component";
import { MessageDraft, MessagePreview } from "../../models/message";
import { SharedMessageRepositoryTable } from "../../repositories/shared-message-repository-table";
import { LoadingComponent } from "../loading/loading.component";
import { PurchaseComponent } from "../../stripe/purchase/purchase.component";
import { NavStore, ScreenStore, UserStore } from "../../stores/index";
import { CentsToDollarsPipe } from "@shared/src/public-api";
import { CellClickedEvent } from "ag-grid-community";

@Component({
	selector: "jhm-inbox",
	templateUrl: "./inbox.component.html",
	styleUrls: ["./inbox.component.scss"],
	imports: [
		JhmTableComponent,
		PurchaseComponent,
		LoadingComponent,
		CentsToDollarsPipe
	]
})
export class InboxComponent implements OnDestroy
{
	public messageRepository: SharedMessageRepositoryTable;
	public unlockMessage: MessagePreview;
	public showConfirmDeleteModal: boolean = false;
	public actionMessage: MessagePreview;
	public refreshTableData: Subject<boolean> = new Subject();
	public userType: string;
	public showStripeModal: boolean = false;
	public creditsAvailable: number = 0;
	public loading: boolean = false;
	public screenSize: string;
	private router: Router;
	public ngDestroyed$: Subject<any> = new Subject();

	readonly userStore = inject(UserStore);
	readonly screenStore = inject(ScreenStore);
	readonly navStore = inject(NavStore);

	public constructor(messageRepository: SharedMessageRepositoryTable, router: Router)
	{
		this.messageRepository = messageRepository;
		this.messageRepository.setRepositoryPurpose("INBOX");
		this.router = router;

		effect(() => {
			this.userType = this.userStore.type();
			this.creditsAvailable = this.userStore.credits();
		})

		effect(() => {
			this.screenSize = this.screenStore.screenSize();
		})
	}

	ngOnDestroy(): void
	{
		this.ngDestroyed$.next(true);
	}

	public onNewMessageClick(): void
	{
		this.loading = true;
		this.messageRepository.createMessageDraft().subscribe((draftSub: Observable<MessageDraft>) =>
		{
			draftSub.subscribe(
				(messageDraft: MessageDraft) =>
				{
					this.loading = false;
					this.router.navigate(["drafts/messages/" + messageDraft.id]);
				});
		});
	}

	public messageClicked(event: CellClickedEvent): void
	{
		const message: MessagePreview = event.data;
		if (event.colDef.field === "delete") {
			this.messageRepository.deleteIncomingMessage(message.id).subscribe(() => {
				this.refreshTableData.next(true);
			})
		}
		else {
			if (message.isPaid || this.userType === "INMATE")
			{
				this.router.navigate(["inbox/messages/" + message.id]);
			}
			else
			{
				this.unlockMessage = message;
			}
		}
	}

	public deleteMessage(): void
	{
		this.messageRepository.deleteIncomingMessage(this.actionMessage.id).subscribe(() =>
		{
			this.showConfirmDeleteModal = false;
			this.refreshTableData.next(true);
		});
	}

	public openNav(): void
	{
		this.navStore.open();
	}

	public closeUnlockModalClicked(): void
	{
		this.unlockMessage = null;
	}

	public greyedOutRowFunction(row: MessagePreview)
	{
		return row.openedSecondsFromEpoch !== 0 && row.openedSecondsFromEpoch !== null;
	}

	public standOutFunction(row: MessagePreview)
	{
		return !row.isPaid;
	}

	public unlockMessageClicked(): void
	{
		this.messageRepository.purchaseMessage(this.unlockMessage.id).subscribe(() =>
		{
			this.userStore.fetchUser();
			this.router.navigate(["inbox/messages/" + this.unlockMessage.id]);
		});
	}

	public purchaseCreditsClicked()
	{
		this.unlockMessage = null;
		this.showStripeModal = true;
	}
}
